<template>
	<div class="recommend-company">
		<div class="recommend-title">
			同行业企业推荐
		</div>
		<div class="company-list">
			<template v-for="(item,index) in list">
				<!--  @click="tonextnew(item.id)" -->
				<div class="company-item">
					<el-avatar shape="square" :size="45"> {{item.company_name}} </el-avatar>
					<div class="company-right">
						<div class="company-title text-cut1 margin-bottom-4"> {{item.company_name}}</div>
						<div class="margin-bottom-4">
							<el-tag class="bg-blueFF margin-right-8" effect="dark" size="mini ">
								{{item.industry||''}}
							</el-tag>
						</div>
						<div>
							<span class="city_str">#{{item.city_str||''}}</span>
						</div>
					</div>
				</div>
			</template>

		</div>
	</div>
</template>

<script>
	export default {
		props: {
			type: {
				type: [Number, String],
				default: 1, //1企业库推荐 2政策库推荐
			},
			id: {
				type: [Number, String],
				default: 1, //企业或政策id
			},
		},
		data() {
			return {
				list: []
			}
		},
		methods: {
			getlist() {
				const that = this;
				that.$api.user.get_company(res => {
					if(res.code == 1){
						that.list = res.data.list
					}else{
						console.log(error);
					}
				})
				
				// this.$https.post({
				// 		type: "formData",
				// 		api: this.$api.api.interfacenew.get_company,
				// 	}, {
				// 		id: this.id,
				// 		type: this.type
				// 	},
				// 	(res) => {
				// 		that.list = res.data.list
				// 	},
				// 	(error) => {
				// 		console.log(error);
				// 	}
				// );
			},
			tonextnew(id) {
				// console.log('idddddddd',id)
				// this.$router.push({ name: 'comdetail', query: { id: id } });
				let routeUrl = this.$router.resolve({
					name: "comdetail",
					query: {
						id: id
					}
				});

				window.open(routeUrl.href, "_blank");
			},
		},
		created() {
			this.getlist();
		}
	}
</script>

<style lang="scss" scoped>
	.recommend-company {
		width: 280px;
		background-color: #FFF;
		border-radius: 10px;

		.recommend-title {
			height: 50px;
			display: flex;
			align-items: center;
			padding: 0px 15px;
			font-size: 18px;
			font-weight: bold;
		}

		.company-list {
			.company-item {
				display: flex;
				border-top: solid #EEE 1px;
				padding: 15px 15px 10px;
				cursor: pointer;
			}

			.company-right {
				flex: 1;
				margin-left: 10px;
			}

			.company-title {
				font-size: 15px;
			}

			.city_str {
				// font-size: 14px;
				color: #AFACA8;
			}
		}

	}
</style>



// WEBPACK FOOTER //
// recommend.vue?7a7c4d27